var App = App || {};

App.PromotionsCarousel = (function ($) {
    'use strict';

    function init() {
        const component = $(".promotion-carousel");
        var elms = component.find(".promotion-carousel__container .splide");


        for (var i = 0; i < elms.length; i++) {
            var displayArrowsLg = true;
            var displayArrowsMd = true;
            var displayArrowsSm = true;

            if ($(".promotion-carousel .card").length < 5) {
                var displayArrowsLg = false;
            }

            if ($(".promotion-carousel .card").length < 4) {
                var displayArrowsMd = false;
            }

            if ($(".promotion-carousel .card").length < 1) {
                var displayArrowsSm = false;
            }

            new Splide(elms[i], {
                mediaQuery: 'min',
                arrows: displayArrowsSm,
                pagination: false,
                type: 'loop',
                perMove: 1,
                start:1,
                perPage:1,
                gap: 0,
                trimSpace: true,
                fixedWidth: '100%',
                omitEnd:true,
                breakpoints: {
                    992: {
                        focus: 1,
                        fixedWidth: '33%',
                        drag: false,
                        arrows: displayArrowsMd,
                    },
                    1140: {
                        focus: 1,
                        fixedWidth: '25%',
                        drag: false,
                        arrows: displayArrowsLg,

                    },

                }
            }).mount();
        };
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.PromotionsCarousel.init();
});